import { Button, Stack, Typography } from '@mui/material';
import { MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

import { TicketFragment } from 'types/api/tickets.types';
import { LocalCartItem } from 'types/tickets.types';

import TicketItemAccordion from './TicketItemAccordion';

interface Props {
  ticket: TicketFragment;
  cartItem: LocalCartItem | undefined;
  onSelectSeats: (ticket: TicketFragment) => void;
}

const TicketSeatingItem = ({ ticket, cartItem, onSelectSeats }: Props) => {
  const handleSelectSeats: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onSelectSeats(ticket);
  };

  return (
    <TicketItemAccordion ticket={ticket}>
      <Stack>
        {!!cartItem && (
          <Typography
            variant="extraSmall"
            sx={{
              textAlign: 'right',
            }}
          >
            <FormattedMessage
              id="event.seating.selected"
              values={{ amount: cartItem.quantity }}
            />
          </Typography>
        )}
        <Button
          variant="text"
          onClick={handleSelectSeats}
          sx={{
            whiteSpace: 'nowrap',
            color: !!cartItem ? 'grey.200' : 'grey.400',
          }}
        >
          {!!cartItem ? (
            <FormattedMessage id="event.seating.change_seats" />
          ) : (
            <FormattedMessage id="event.seating.select_seats" />
          )}
        </Button>
      </Stack>
    </TicketItemAccordion>
  );
};

export default TicketSeatingItem;
